import axios from './axios'

function authService(endpoint = 'auth') {
    const base = endpoint || 'auth';

    function login(data) {
        return axios.post(`${base}/login`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function logout() {
        return axios.post(`${base}/logout`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function me() {
        return axios.get(`${base}/me`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        login,
        logout,
        me
    }
}

export default authService
